<template>
  <popup-modal v-model="showPopup" class="page-con" v-body :transitionName="'slide-in-right'" :top="0">
    <div class="alert-labels-modal">
      <div class="title-wrapper">
        <span class="img-wrapper">
          <img :src="ExplanationIcon" class="img-responsive" alt="" />
        </span>
        <span class="text">
          {{ $t('commonForm-1.key71', { cm: '系统将在下次提交时再次验证，因此该页面数据可能会与修改后数据有误差' }) }}
        </span>
      </div>
      <div class="date-info" v-if="date">
        <span class="date">
          {{ date }}
        </span>
        <span>{{ $t('commonForm-1.key20', { cm: '检查结果' }) }}</span>
      </div>
      <section class="tips">
        <tips-more :key="index" v-for="(info, index) in labels" :dataSource="info" />
        <tips-more v-if="invoiceExcessReason" :data-source="standardExceededReason" />
        <tips-more v-if="standardExceededApprovalRecords" :data-source="standardExceededApprovalRecords" />
      </section>
    </div>
  </popup-modal>
</template>
<script>
import PopupModal from 'components/base-ui/popup-modal';
import tipsMore from '@/components/business/expense-list/detail/tips-more/index';
import { dateFormat } from 'utils';
import ExplanationIcon from '@/assets/images/refactor-main/explanation-row-icon@2x.png';

export default {
  name: 'alert-labels-modal',
  data() {
    return {
      showPopup: false,
      ExplanationIcon,
    };
  },
  computed: {
    date() {
      if (this.submitedDate) {
        return dateFormat(this.submitedDate, 'yyyy-MM-dd hh:mm');
      }
      return '';
    },
    standardExceededReason() {
      if (!this.invoiceExcessReason.standardExceededReason) return {};
      return {
        name: window.$t('global-1.key322', { cm: '原因说明' }),
        toast: this.invoiceExcessReason.standardExceededReason,
      };
    },
    standardExceededApprovalRecords() {
      if (!this.COMMON.getValue(this.invoiceExcessReason, 'standardExceededApprovalRecords.length')) return {};
      return {
        name: window.$t('expense-2.key159', { cm: '审批理由' }),
        toast: this.invoiceExcessReason.standardExceededApprovalRecords
          .map(
            (c) =>
              `${c.approvalUserName || c.exceedStandardApprovalUserName} - ${c.record || c.exceedStandardApprovalIdea}`
          )
          .join('\u001E'),
      };
    },
  },
  props: {
    submitedDate: String,
    value: {
      type: Boolean,
    },
    labels: {
      type: Array,
      default() {
        return [{}];
      },
    },
    invoiceExcessReason: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
  },
  methods: {},
  components: {
    PopupModal,
    tipsMore,
  },
};
</script>
<style lang="scss" scoped>
.alert-labels-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
}

.title-wrapper {
  padding: px(28) px(30);
  box-sizing: border-box;
  background: #f8f8f8;
  display: flex;

  .img-wrapper {
    flex: none;
    width: px(24);
  }

  .text {
    flex: 1;
    padding-left: px(16);
    color: #505564;
    font-size: px(26);
  }
}

.date-info {
  padding: px(28) px(30);
  background: #fff;
  color: #505564;
  font-size: px(28);
}

.tips {
  padding: 0 px(20);
  background: #ffffff;
  flex: 1;
  overflow-y: auto;

  .excess-record {
    margin-top: px(30);
  }

  .excess-record-header {
    background: #f4f4f4;
    font-size: px(30);
    color: #949494;
    height: px(64);
    display: flex;
    align-items: center;
    padding-left: px(20);
    font-weight: bold;
  }

  .excess-record-content {
    margin: px(20);
    font-size: px(28);
    color: #505564;
    line-height: px(40);
    word-break: break-word;
  }

  .excess-record-username {
    font-weight: 600;
  }
}
</style>
